import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMobileHeader } from "hooks/useMobileHeader";
import { convertToTitleCase } from "js/formatting";

import config from "config/config";
import { getImage } from "js/utilities";

export default function PayeeHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { open: openMobileMenuNav } = useMobileHeader();

  // mobile menu trap focus
  const mobileMenuButton = useRef(null);

  return (
    <>
      <header className="lg:bg-white shadow-drop lg:sticky lg:top-0 lg:z-20">
        <a className="ui-skip-to-content" href="#mainContent">
          {t("AuthHeader-skip-content")}
        </a>
        <div id="id_header">
          <div id="id_headerTopBar">
            <div id="id_utilityMenu" className="ui-utilitybar">
              <div className="container py-4">
                <div className="flex justify-between flex-row-reverse items-center lg:grid lg:gap-x-2 lg:grid-cols-[1fr_max-content_max-content_max-content_max-content] lg:items-center">
                  <div className="lg:flex lg:items-center">
                    <div className="lg:flex">
                      <div id="everlakeLogoHeader">
                        <img
                          src={getImage("logo_blue.png")}
                          className="ui-logo-header"
                          alt={`${convertToTitleCase(
                            config.COMPANY_NAME
                          )} Logo`}
                        />
                      </div>
                    </div>
                    <div className="hidden lg:flex text-[color:var(--theme-color-portal-title)] font-semibold ml-6 px-6 border-l border-theme-rule">
                      {t("AuthHeader-header-title-1")}
                    </div>
                  </div>

                  <button
                    aria-label={t("AuthHeader-button-2")}
                    title={t("AuthHeader-button-2")}
                    className="ui-btn-icon h-7 w-7 rounded-full hidden lg:flex lg:items-center lg:justify-center"
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    <svg
                      className="ui-icon w-4 h-4"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-signout"></use>
                    </svg>
                  </button>

                  <button
                    id="id_menuBtn"
                    ref={mobileMenuButton}
                    onClick={openMobileMenuNav}
                    aria-label="Main"
                    aria-expanded="false"
                    aria-controls="id_mainMenu"
                    className="ui-btn-icon h-8 w-8 flex items-center justify-center rounded-full m-0 lg:hidden"
                  >
                    <svg
                      className="ui-icon w-5 h-4"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-menu"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="id_mainMenu" role="menubar">
            <div className="ui-navbar w-64 lg:flex lg:w-full lg:z-auto lg:relative">
              <div
                id="id_mobileMenuMask"
                className="hidden fixed inset-0 w-full h-full bg-ui-gray-dark opacity-40 z-[800] lg:hidden lg:inset-auto lg:z-auto"
              />

              <nav
                aria-label="Main"
                className="ui-main-menu hidden absolute w-64 z-[802] bottom-0 bg-white lg:flex lg:relative lg:w-full lg:z-auto lg:inset-auto lg:bg-transparent lg:container"
              >
                <div className="flex flex-col justify-between h-full">
                  {/* mobile menu utility bar icons */}
                  <div className="mt-8 lg:hidden">
                    <ul className="ui-disclosure-nav">
                      <li
                        onKeyDown={(e) => {
                          if (
                            e.key === "Tab" &&
                            localStorage.getItem("isMobileHeaderMenuOpen") &&
                            localStorage.getItem("isMobileHeaderMenuOpen") ===
                              "true"
                          )
                            setTimeout(() => {
                              mobileMenuButton.current.focus();
                            }, 5);
                        }}
                      >
                        <a
                          href="/"
                          className="ui-main-link"
                          onClick={() => {
                            navigate("/");
                          }}
                        >
                          <svg
                            className="ui-icon w-4.5 h-4.5 text-ui-blue mr-2"
                            focusable="false"
                            aria-hidden="true"
                            role="presentation"
                          >
                            <use href="#ui-icon-signout"></use>
                          </svg>
                          {t("AuthHeader-nav-link-8")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
